export default __webpack_public_path__ + "static/media/whizzardLogoTextOnly.0b87eccf.svg";